<form [formGroup]="emailForm" (ngSubmit)="onSubmit()">
  <div class="email-container">
    <input type="email" placeholder="Email Address" class="email-input" formControlName="email" />
    <app-button (onClick)="onSubmit()" (ngSubmit)="onSubmit()" label="Notify Me" class="email-button"></app-button>
  </div>
  <div *ngIf="email.invalid && email.touched" class="error-message">
    <p *ngIf="email.errors?.['required']">Email is required.</p>
    <p *ngIf="email.errors?.['email']">Please enter a valid email address.</p>
  </div>
</form>
<span *ngIf="success == true" class="text-success mt-2 text-small"> {{'Thank you for signing up! We\'ll notify you assoon as our site is live.' | translate}}</span>